import { Box } from "@mui/material";
import React from "react";
import CustomModal from "./CustomModal";

interface ExportDashboardProps {
  open: boolean;
  closeModal: () => void;
  onPrint: () => void;
}

const ExportDashboard: React.FC<ExportDashboardProps> = ({
  open,
  closeModal,
  onPrint,
}) => (
  <CustomModal
    title="Export dashboard as PDF"
    open={open}
    closeModal={closeModal}
    cancelButton={{
      label: "Cancel",
      type: "outlined",
    }}
    confirmButton={{
      label: "Open print dialog",
      onClick: onPrint,
    }}
  >
    {() => (
      <Box>
        <p>
          Your browser&apos;s print dialog will open with all dashboard sections
          and charts from the currently applied filters.
        </p>
        <ol>
          <li>
            Set <strong>Destination</strong> to <strong>Save as PDF</strong>.
          </li>
          <li>
            Set <strong>Layout</strong> to <strong>Landscape</strong>.
          </li>
          <li>
            In <strong>More settings</strong>, enable{" "}
            <strong>Background graphics</strong>.
          </li>
          <li>
            Select <strong>Save</strong>.
          </li>
        </ol>
      </Box>
    )}
  </CustomModal>
);

export default ExportDashboard;
